import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import HomeLanding from './pages/home-landing';
import ContactForm from './pages/contact-form';
import ProjectsShowcase from './pages/project-showcase';
import ProjectDetailsPage from './pages/project-details';
import AboutProfile from './pages/about-profile';
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import ProtectedRoute from './components/admin/ProtectedRoute';

const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your routes here */}
          <Route path="/" element={<HomeLanding />} />
          <Route path="/home-landing" element={<HomeLanding />} />
          <Route path="/contact-form" element={<ContactForm />} />
          <Route path="/projects-showcase" element={<ProjectsShowcase />} />
          <Route path="/project-details" element={<ProjectDetailsPage />} />
          <Route path="/about-profile" element={<AboutProfile />} />

          {/* Admin Routes */}
          <Route path="/Yabetskifleadmin/login" element={<Login />} />
          <Route
            path="/Yabetskifleadmin"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
